import '../../styles-new/pages/tags.scss';
import generateTabs from '../components/generateTabs';

generateTabs('sidebar-last', { isLoadMore: true });
